import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, Paper, Typography } from '@material-ui/core';
import {
  ArrowDownward,
  ArrowUpward,
  HighlightOff,
  Launch,
  PictureAsPdf,
} from '@material-ui/icons';
import { useAttachmentCardStyles } from './attachmentCardStyles';

const PdfAttachmentComponent = ({
  index,
  onMove,
  onRemoveAttachment,
  onViewPdf,
  pdfAttachment,
  totalAttachments,
}) => {
  const classes = useAttachmentCardStyles();
  const fileName = pdfAttachment.titolo || 'Nome allegato.pdf';

  const isFirst = index === 0;
  const isLast = index === totalAttachments - 1;

  return (
    <div className={classes.gridElement}>
      <Paper className={classes.paper}>
        <div className={classes.card}>
          <div className={classes.mediaSection}>
            <PictureAsPdf color="primary" className={classes.pdfIcon} />
          </div>

          <div className={classes.contentSection}>
            <Typography
              align="left"
              className={classes.truncatedText}
              title={fileName}
            >
              {fileName}
            </Typography>
            <div className={classes.footerRow}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<Launch />}
                onClick={() => onViewPdf(pdfAttachment.id)}
                disabled={!pdfAttachment?.id}
                className={classes.viewButton}
              >
                Visualizza pdf
              </Button>
            </div>
          </div>

          <div className={classes.actionsSection}>
            <IconButton
              color="primary"
              size="small"
              aria-label="Rimuovi allegato"
              onClick={() => onRemoveAttachment(pdfAttachment.id)}
            >
              <HighlightOff />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              aria-label="Sposta su"
              disabled={isFirst}
              onClick={() => onMove(index, index - 1)}
            >
              <ArrowUpward style={{ color: isFirst ? 'gray' : 'inherit' }} />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              aria-label="Sposta giù"
              disabled={isLast}
              onClick={() => onMove(index, index + 1)}
            >
              <ArrowDownward style={{ color: isLast ? 'gray' : 'inherit' }} />
            </IconButton>
          </div>
        </div>
      </Paper>
    </div>
  );
};

PdfAttachmentComponent.propTypes = {
  index: PropTypes.number,
  onMove: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  onViewPdf: PropTypes.func.isRequired,
  pdfAttachment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    titolo: PropTypes.string,
  }),
  totalAttachments: PropTypes.number,
};

export default PdfAttachmentComponent;
